<template>
    <div>
        <Transition v-if="isLoading"
                    name="spinner">
            <div id="cover-spin">
                <span class="loader">
                    <span>{{ $spinnerText }}</span>
                </span>
            </div>
        </Transition>

        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :initialSort="initialSort"
                :showModeOpenId="showModeOpenId"
                :viewParams="viewParams"
                :buttonsVisibility="buttonsVisibility"
                v-model:selectedRows="selectedRows">

            <template #crud="formProps">
                <CostForm :formProps="formProps">
                </CostForm>
            </template>
            <template #search="searchProps">
                <CostSearch :searchProps="searchProps">
                </CostSearch>
            </template>

            <template #buttons="formProps">
                <CustomButton name="changeStatus"
                              @click.stop="changeStatus(formProps)"
                              :className="buttonClass('green')">
                    <template class="flex items-center gap-1"><i class="fa-solid fa-list-check"></i><span>{{ __('Change status') }}</span></template>
                </CustomButton>

            </template>
        </v-view>

        <Dialog modal
                :visible="isChangeStatusModalOpen"
                v-model:visible="isChangeStatusModalOpen"
                :header="__('Change status')"
                :style="{ width: '800px' }"
                :pt="dialogPt">
            <p style="font-size:16px; font-weight:bold;color:cadetblue">{{ __('Changing status for selected costs documents') }}</p>

            <ChangeStatusForm :selectedRows="selectedRows"
                              :formProps="formPropsToPass"
                              :currentStatusId="selectedRows[0]?.status_id"
                              v-model:isChangeStatusModalOpen="isChangeStatusModalOpen">
            </ChangeStatusForm>
        </Dialog>

    </div>
</template>

<script setup>
import { ref } from "vue";
import Dialog from 'primevue/dialog';
import CostForm from './CostForm.vue'
import CostSearch from './CostSearch.vue'
import ChangeStatusForm from './ChangeStatusForm.vue'
import CustomButton from '@crud/CustomButton.vue'
import { __, getFromUrl, buttonClass, screenMessage } from '@pages/Helper/utils.js';

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    initialSort: Object,
    viewParams: Object,
    buttonsVisibility: Object,
})

const selectedRows = ref([])
const showModeOpenId = getFromUrl()
const isLoading = ref(false)
const isChangeStatusModalOpen = ref(false)
const formPropsToPass = ref(null)
const dialogPt = {
    header: { class: 'form-header' },
    content: { class: 'form-body' },
};

//------------------------------------------------------------------------------

function changeStatus(formProps) {
    if (!Array.isArray(selectedRows.value) || selectedRows.value.length === 0) {
        const message = {
            message: "No document has been selected",
            title: "Cost document selection error",
            type: "error",
            position: "center",
            timeout: 5,
        };
        screenMessage(message);
        return false;
    }

    isChangeStatusModalOpen.value = true
    formPropsToPass.value = formProps;
}

//------------------------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
